import React, { FC } from "react";

export const ToolbarBrand: FC = () => {
    return (
        <a href="https://petsaviors.app/" className="flex items-center">
            <img src={require("../../../../resources/images/logo.png")} className="mr-3 mt-0 lg:mt-2" alt="Petsaviors logo" width={240} />
        </a>
    );
}